import { SENSOR_DATA_DOMAIN } from "../url/urls_in_app";

/**
 |--------------------------------------------------
 | This function is responsable for making the call,
 | use a single instance and return a promise
 | Takes as parameter URL_STRING that is a url string.
 | URL_STRING are taken from ../url/urls_in_app
 | @param {URL_STRING} URL_ADITION
 |--------------------------------------------------
 */

export const API_CLIENT = (URL_ADITION, options) => {
	let ajaxconfig;
	let defaultconfig = {
		url: SENSOR_DATA_DOMAIN + URL_ADITION,
		contentType: "application/json",
		responseType: "application/json",
		dataType: "jsonp",
	};
	if (options) {
		ajaxconfig = { ...defaultconfig, ...options };
	} else {
		ajaxconfig = defaultconfig;
	}
	return $.ajax(ajaxconfig);
};

/**
|--------------------------------------------------
| Responsible for getting historical data
|--------------------------------------------------
*/

export const API_CLIENT_GET_AXIOS = (URL_ADITION) => {
	return axios
		.get(SENSOR_DATA_DOMAIN + URL_ADITION)
		.then((response) => {
			return response.data;
		})
		.catch((err) => {
			console.log("err in axios");
		});
};

/**
|--------------------------------------------------
| Responsible for posting the raport and reply
|--------------------------------------------------
*/
export const API_CLIENT_POST_AXIOS = (URL_ADITION, FORM_DATA) => {
	return axios({
		method: "POST",
		url: SENSOR_DATA_DOMAIN + URL_ADITION,
		data: JSON.stringify(FORM_DATA),
		type: "json",
	});
};

/**
|--------------------------------------------------
| Used to make get call
   Small changes may break operation in other places where implemented other than organisations
|--------------------------------------------------
*/

export const API_CLIENT_GET = (API_URL) => {
	return axios
		.get(API_URL)
		.then((response) => {
			return response.data;
		})
		.catch((err) => {
			console.log("err in axios");
		});
};

/**
|--------------------------------------------------
| Used to make get call with specific id
| Also includes axiosConfig
|--------------------------------------------------
*/

let axiosConfig = {
	headers: {
		"Content-Type": "application/json",
	},
};

export const API_CLIENT_GET_ID = (API_URL, id) => {
	const url = `${API_URL}${id}`;
	return axios
		.get(url, axiosConfig)
		.then((response) => {
			return response.data;
		})
		.catch((err) => {
			console.log("Error in axios:", err);
		});
};

/**
|--------------------------------------------------
| Used to make post call 
|--------------------------------------------------
*/

export const API_CLIENT_POST_FORM = (URL, FORM_DATA) => {
	return axios({
		method: "POST",
		url: URL,
		data: FORM_DATA,
		type: "json",
	});
};
